import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { parseLocalDate } from '../../../utils/dateUtils';

const ResourceConflictAlert = ({ conflicts }) => {
  if (!conflicts || conflicts?.length === 0) return null;

  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div className="flex items-start gap-3">
        <Icon name="AlertTriangle" size={20} color="#E74C3C" className="flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-red-800 mb-2">
            Resource Conflicts Detected
          </h3>
          <p className="text-sm text-red-700 mb-3">
            The following resources have overlapping assignments:
          </p>
          <div className="space-y-3">
            {conflicts?.map((conflict, index) => (
              <div key={index} className="bg-white rounded-lg p-3 border border-red-200">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 rounded-full overflow-hidden bg-muted flex-shrink-0">
                    {conflict?.resource?.avatar ? (
                      <Image
                        src={conflict?.resource?.avatar}
                        alt={conflict?.resource?.avatarAlt}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-primary text-primary-foreground text-xs font-medium">
                        {conflict?.resource?.name?.charAt(0)}
                      </div>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground">
                      {conflict?.resource?.name}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      {conflict?.resource?.type}
                    </p>
                  </div>
                </div>
                <div className="space-y-1">
                  {conflict?.overlappingAssignments?.map((assignment, idx) => (
                    <div key={idx} className="text-xs text-red-700 flex items-center gap-2">
                      <Icon name="Calendar" size={12} />
                      <span>
                        {assignment?.deliverable} ({parseLocalDate(assignment?.startDate)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - {parseLocalDate(assignment?.endDate)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })})
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourceConflictAlert;